import type { UserProfile } from './user-profile';


// Бэкенд не отдаёт ключ `team`, когда фича команд выключена.
export const isTeamEnabled = (profile: UserProfile | null): boolean => Boolean(profile?.team);
